import React, { useEffect, useState, SVGAttributes } from 'react'
import { Box, ThemeUIStyleObject } from 'theme-ui'

export interface SvgProps extends SVGAttributes<SVGAElement> {
  svg: React.ElementType
  fill?: string
  descriptiveText?: string
  sx?: ThemeUIStyleObject
  children?: React.ReactNode
}

export default function Svg(props: SvgProps): React.ReactElement {
  const { svg, fill, sx = {}, descriptiveText = '', children, ...rest } = props
  const [svgStyles, setSvgStyles] = useState<ThemeUIStyleObject>({
    ...sx,
    '& > path,g': {
      fill,
    },
  })

  useEffect(() => {
    setSvgStyles(prevStyles => ({
      ...prevStyles,
      '& > path,g': {
        fill,
      },
    }))
  }, [fill])

  return (
    <Box
      as={svg}
      role="img"
      // @ts-ignore
      alt={descriptiveText}
      title={descriptiveText}
      sx={svgStyles}
      {...rest}
    >
      {children}
    </Box>
  )
}
